import React, { useEffect, useState } from "react";
import { Field } from "formik";
import { DateRangePicker } from "react-dates";
import Autocomplete from "@material-ui/lab/Autocomplete";
import CurrencyInput from "react-currency-input-field";
import moment from "moment";
import TextField from "@material-ui/core/TextField";
import {
  GoogleMap,
  Marker,
  Autocomplete as GoogleAutoComplete,
  LoadScriptNext
} from "@react-google-maps/api";
import {
  Card,
  CardBody,
  CardHeader,
  CardHeaderToolbar,
  Input
} from "../../../../../_metronic/_partials/controls";
import { findDistrict } from "../../../MasterData/_redux/province/provinceCrud";

export function ProjectEditForm({ history, setFieldValue, values }) {
  const [onFocused, setOnFocused] = useState(null);
  const [tanggal, setTanggal] = useState({
    start_date: values.begin_date,
    end_date: values.end_date
  });
  const [kotaValue, setKotaValue] = useState("");
  const [district, setDistrict] = useState([]);
  const [mapCenter, setMapCenter] = useState({ lat: -1.8479, lng: 120.5279 });
  const [autocomplete, setAutocomplete] = useState(null);

  useEffect(() => {
    if (values.uuid) {
      setKotaValue(`${values.district}, ${values.city}, ${values.province}`);
      setTanggal({
        start_date: moment(values.begin_date),
        end_date: moment(values.end_date)
      });
    }
  }, [values]);

  function onAutoCompleteLoad(autocomplete) {
    setAutocomplete(autocomplete);
  }

  function onPlaceChanged() {
    if (!autocomplete) {
      return;
    }

    const { geometry } = autocomplete.getPlace();

    setFieldValue("latitude", geometry.location.lat());
    setFieldValue("longitude", geometry.location.lng());
  }

  function onSelectTag(value, setFieldValue) {
    const array = value.split(",");
    if (array.length === 3) {
      let index = district.findIndex(
        i =>
          i.district === array[0].trim() &&
          i.city === array[1].trim() &&
          i.province_name === array[2].trim()
      );

      setFieldValue("province", district[index].province_name);
      setFieldValue("city", district[index].city);
      setFieldValue("district", district[index].district);
      setKotaValue(
        `${district[index].district}, ${district[index].city}, ${district[index].province_name}`
      );
    }
  }

  function onInputChange(e) {
    const value = e.target.value;

    if (value.length >= 3) {
      let query = {
        district: value,
        city: value
      };
      findDistrict(query).then(response => {
        setDistrict(response.data.data);
      });
    }
  }

  function getDefaultLatLng() {
    const { latitude = -1.8479, longitude = 120.5279 } = values;

    return { lat: latitude, lng: longitude };
  }

  return (
    <Card>
      <CardHeader title="Project Form">
        <CardHeaderToolbar>
          <button
            className="btn btn-secondary"
            onClick={() => history.push("/_distribution/project")}
          >
            <i className="fa fa-arrow-left" />
            Kembali
          </button>
        </CardHeaderToolbar>
      </CardHeader>
      <CardBody>
        <div className="row">
          <div className="col-lg-4">
            <Field
              name="name"
              label="Nama Projek"
              placeholder="Nama Projek"
              component={Input}
            />
          </div>
          <div className="col-lg-4">
            <label>Target Penerimaan</label>
            <CurrencyInput
              name="target_revenue"
              placeholder="Target Penerimaan"
              intlConfig={{ locale: "id-ID", currency: "IDR" }}
              className="form-control"
              // defaultValue={values.goods_qty_price ?? ""}
              value={values.target_revenue}
              decimalsLimit={2}
              label="Jumlah"
              onValueChange={(value, name) => {
                setFieldValue(name, value);
                // handleSubmit()
              }}
            />
          </div>
          <div className="col-lg-4">
            <label>Periode Tanggal</label>
            <DateRangePicker
              small={true}
              startDate={tanggal.start_date}
              endDate={tanggal.end_date}
              onDatesChange={({ startDate, endDate }) => {
                setTanggal({
                  start_date: startDate,
                  end_date: endDate
                });
                setFieldValue("begin_date", startDate);
                setFieldValue("end_date", endDate);
              }}
              focusedInput={onFocused}
              onFocusChange={focusedInput => setOnFocused(focusedInput)}
              numberOfMonths={1}
              isOutsideRange={() => false}
              showClearDates={true}
              startDateId="begin_date"
              endDateId="end_date"
              hideKeyboardShortcutsPanel={true}
            />
          </div>
        </div>
        <div className="row mt-4">
          <div className="col-lg-4">
            <label>Deskripsi</label>
            <textarea
              name="description"
              className="form-control"
              value={values.description}
              label="Deskripsi Projek"
              placeholder="Deskripsi Projek"
              onChange={e => setFieldValue("description", e.target.value)}
            />
          </div>
        </div>
        <div className="row mt-4">
          <div className="col-lg-8">
            <Autocomplete
              id="searchPostalCode"
              disableClearable
              onChange={(e, value) => {
                onSelectTag(value, setFieldValue);
              }}
              value={kotaValue}
              options={district.map(
                option =>
                  `${option.district}, ${option.city}, ${option.province_name}`
              )}
              renderInput={params => (
                <TextField
                  {...params}
                  label="Cari Kota / Kecamatan"
                  margin="normal"
                  variant="outlined"
                  InputProps={{
                    ...params.InputProps,
                    type: "search"
                  }}
                  onChange={e => {
                    onInputChange(e);
                  }}
                />
              )}
            />
          </div>
        </div>
        <div className="row mt-4">
          <div className="col">
            <label htmlFor="latitude">Latitude</label>
            <Field name="latitude" component={Input} />
          </div>
          <div className="col">
            <label htmlFor="longitude">Longitude</label>
            <Field name="longitude" component={Input} />
          </div>
        </div>
        <div className="row mt-4">
          <div className="col">
            <label htmlFor="input_address">Pilih Lokasi</label>
            {/* {isLoaded && (
              <GoogleAutoComplete
                onLoad={onAutoCompleteLoad}
                onPlaceChanged={onPlaceChanged}
              >
                <input
                  id="input_address"
                  name="location"
                  className="form-control"
                  placeholder="Cari Lokasi"
                />
              </GoogleAutoComplete>
            )} */}

            <LoadScriptNext
              googleMapsApiKey={process.env.REACT_APP_MAP_API_KEY}
              libraries={["places"]}
            >
              <GoogleAutoComplete
                onLoad={onAutoCompleteLoad}
                onPlaceChanged={onPlaceChanged}
              >
                <input
                  id="input_address"
                  name="location"
                  className="form-control mb-5"
                  placeholder="Cari Lokasi"
                />
              </GoogleAutoComplete>
              <GoogleMap
                zoom={4}
                center={mapCenter}
                mapContainerStyle={{
                  height: "450px",
                  width: "100%"
                }}
                onClick={({ latLng }) => {
                  const lat = latLng.lat();
                  const lng = latLng.lng();

                  setFieldValue("latitude", lat);
                  setFieldValue("longitude", lng);
                }}
              >
                {values.latitude && values.longitude && (
                  <Marker
                    position={{
                      lat: +values.latitude,
                      lng: +values.longitude
                    }}
                  />
                )}
              </GoogleMap>
            </LoadScriptNext>
          </div>
        </div>
      </CardBody>
    </Card>
  );
}
